var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChatIcon = function SvgChatIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 52,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.864 51a3.776 3.776 0 0 1-1.644-.407A3.763 3.763 0 0 1 1 47.17V22.186C1 10.486 10.571 1 22.377 1H36.29c11.807 0 21.378 9.485 21.378 21.186s-9.571 21.187-21.378 21.187H16.08L7.167 50.2A3.903 3.903 0 0 1 4.864 51ZM22.41 5.042c-9.55.009-17.29 7.68-17.299 17.144v24.446l9.011-6.796a2.082 2.082 0 0 1 1.267-.505h20.933c9.123-.558 16.233-8.054 16.233-17.112 0-9.058-7.11-16.554-16.233-17.112L22.41 5.042Z",
    stroke: "#FFF",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.17 19.4H18.562a2.046 2.046 0 0 1-2.055-2.038c0-1.125.92-2.037 2.055-2.037H40.17c1.135 0 2.056.912 2.056 2.037 0 1.126-.92 2.038-2.056 2.038Zm-9.768 9.974h-11.84a2.046 2.046 0 0 1-2.055-2.038c0-1.125.92-2.037 2.055-2.037h11.84c1.135 0 2.056.912 2.056 2.037s-.92 2.038-2.056 2.038Z",
    fill: "#2A7776"
  }))));
};
export default SvgChatIcon;